// extracted by mini-css-extract-plugin
module.exports = {"fuel-grade-price":"FuelGradePrices_fuel-grade-price__16Uv6","buttons":"FuelGradePrices_buttons__g0Cfy"};